module.exports = __webpack_public_path__ + "static/media/logo.905ec330.png";